import React, { useState } from 'react';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Snackbar,
  TextField,
  Typography,
} from '@mui/material';
// import axios from 'axios';
// import { PartnerSafeApi } from './EnvFiles';
// import { getStoredToken } from "../utils/getStoredToken";

const CreateTeam = () => {
  // const [isLoading, setIsLoading] = useState(false);
  const [isLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  const [teamData, setTeamData] = useState({
    nomeEquipe: '',
  });

  const [teamError, setTeamError] = useState({
    nomeEquipe: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setTeamData((prev) => ({ ...prev, [name]: value }));
    setTeamError((prev) => ({ ...prev, [name]: '' }));
  };

  const validateForm = () => {
    let isValid = true;
    const errors = {};

    if (!teamData.nomeEquipe) {
      isValid = false;
      errors.nomeEquipe = 'Nome da equipe é obrigatório';
    }

    setTeamError(errors);
    return isValid;
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      setSnackbarSeverity('error');
      setSnackbarMessage('Por favor, preencha o campo corretamente.');
      setSnackbarOpen(true);
      return;
    }

    console.log('DADOS DA EQUIPE:', teamData);
    setSnackbarSeverity('success');
    setSnackbarMessage('Equipe cadastrada com sucesso!');
    setSnackbarOpen(true);

    // TODO: INTEGRAÇÃO COM A API AINDA NÃO FINALIZADA
    // setIsLoading(true);

    // try {
    //   const response = await axios.post(
    //     `${PartnerSafeApi}/api/v1/Equipes/Cadastrar`,
    //     contractData,
    //     { headers: { Authorization: `Bearer ${token}` } }
    //   );

    //   setSnackbarSeverity('success');
    //   setSnackbarMessage('Contrato cadastrado com sucesso!');
    //   setSnackbarOpen(true);
    // } catch (error) {
    //   setSnackbarSeverity('error');
    //   setSnackbarMessage('Erro ao cadastrar contrato!');
    //   setSnackbarOpen(true);
    //   console.error('Erro ao cadastrar contrato:', error);
    // } finally {
    //   setIsLoading(false);
    // }
  };

  const handleSnackbarClose = () => setSnackbarOpen(false);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
        minHeight: '100vh',
        py: 2,
      }}
    >
      <Typography
        variant="h5"
        sx={{ fontWeight: 600, color: '#40685E', mb: 3 }}
      >
        Cadastro de Equipe
      </Typography>

      {isLoading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', height: '50vh' }}>
          <CircularProgress />
        </Box>
      ) : (
        <Box sx={{ width: '100%', px: 4 }}>
          <TextField
            label="Nome da Equipe *"
            variant="outlined"
            fullWidth
            sx={{ mb: 2 }}
            name="nomeEquipe"
            value={teamData.nomeEquipe}
            onChange={handleChange}
            error={!!teamError.nomeEquipe}
            helperText={teamError.nomeEquipe}
          />

          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
            <Button variant="contained" color="primary" onClick={handleSubmit}>
              Cadastrar Equipe
            </Button>
          </Box>
        </Box>
      )}

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbarSeverity}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default CreateTeam;
